// extracted by mini-css-extract-plugin
module.exports = {"landing":"page_landing__pfGzQ"};